import type { NavGroupDef } from '../navigation/menu.ts'

/** Azione rapida: collegamento a una rotta di creazione GIA' esistente. */
export interface QuickAction { id: string; to: string; label: string; icon: string }

/**
 * Azioni del FAB menu globale. Ciascuna compare solo se il ruolo vede la voce di menu della relativa lista
 * (`menuItemId`): e' la stessa logica di visibilita' del menu (visibleGroups), nessuna regola nuova.
 */
const QUICK: readonly (QuickAction & { menuItemId: string })[] = [
  { id: 'new-contract', to: '/contracts/create', label: 'Nuovo contratto', icon: 'note_add', menuItemId: 'contracts' },
  { id: 'new-lead', to: '/leads/create', label: 'Nuovo lead', icon: 'person_add', menuItemId: 'leads' },
  { id: 'new-customer', to: '/customers/create', label: 'Nuovo cliente', icon: 'person', menuItemId: 'customers' },
  { id: 'new-company', to: '/companies/create', label: 'Nuova azienda', icon: 'business', menuItemId: 'companies' },
]

export function quickActionsFor(groups: NavGroupDef[]): QuickAction[] {
  const ids = new Set(groups.flatMap(g => g.items.map(i => i.id)))
  return QUICK.filter(a => ids.has(a.menuItemId)).map(({ menuItemId: _m, ...a }) => { void _m; return a })
}

/** Sulle rotte di creazione il FAB non compare. */
export function isCreateRoute(pathname: string): boolean {
  return /\/create\/?$/.test(pathname)
}

/** Destinazioni della navigation bar: le prime 4 visibili al ruolo, in ordine di preferenza. */
const BAR_PREFERENCE = [
  { id: 'dashboard', label: 'Home' },
  { id: 'work-queue', label: 'Coda' },
  { id: 'contracts', label: 'Contratti' },
  { id: 'leads', label: 'Lead' },
  { id: 'customers', label: 'Clienti' },
] as const

export interface BarDestination { id: string; to: string; label: string; icon: string }

export function barDestinationsFor(groups: NavGroupDef[]): BarDestination[] {
  const all = groups.flatMap(g => g.items)
  const out: BarDestination[] = []
  for (const p of BAR_PREFERENCE) {
    const it = all.find(i => i.id === p.id)
    if (it) out.push({ id: it.id, to: it.to, label: p.label, icon: it.icon })
    if (out.length === 4) break
  }
  return out
}
